const standardFonts = [
  {
    'name': 'Arial',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      },
      {
        'name': 'Bold',
        'value': 700
      }
    ]
  },
  {
    'name': 'Arial Black',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      },
      {
        'name': 'Bold',
        'value': 700
      }
    ]
  },
  {
    'name': 'Comic Sans MS',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      },
      {
        'name': 'Bold',
        'value': 700
      }
    ]
  },
  {
    'name': 'Impact',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      },
      {
        'name': 'Bold',
        'value': 700
      }
    ]
  },
  {
    'name': 'Charcoal',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      },
      {
        'name': 'Bold',
        'value': 700
      }
    ]
  },
  {
    'name': 'Lucida Sans Unicode',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      },
      {
        'name': 'Bold',
        'value': 700
      }
    ]
  },
  {
    'name': 'Lucida Grande',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      },
      {
        'name': 'Bold',
        'value': 700
      }
    ]
  },
  {
    'name': 'Tahoma',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      },
      {
        'name': 'Bold',
        'value': 700
      }
    ]
  },
  {
    'name': 'Trebuchet MS',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      },
      {
        'name': 'Bold',
        'value': 700
      }
    ]
  },
  {
    'name': 'Verdana',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      },
      {
        'name': 'Bold',
        'value': 700
      }
    ]
  },
  {
    'name': 'Courier New',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      },
      {
        'name': 'Bold',
        'value': 700
      }
    ]
  },
  {
    'name': 'Lucida Console',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      },
      {
        'name': 'Bold',
        'value': 700
      }
    ]
  },
  {
    'name': 'Palatino Linotype',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      }
    ]
  },
  {
    'name': 'Book Antiqua',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      }
    ]
  },
  {
    'name': 'Georgia',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      }
    ]
  },
  {
    'name': 'Times New Roman',
    'variants': [
      {
        'name': 'Regular',
        'value': 400
      }
    ]
  }
]

export const standardFontFamilies = standardFonts.map(font => font.name).sort()